/* eslint-disable @typescript-eslint/no-explicit-any */
import { useState, useEffect, useCallback } from 'react';
import styled from 'styled-components';
import Adress from 'components/Footer/Adress';
import useGlobalAlert from 'hooks/useAlertMessage';
import { clearTokens, setToken } from 'utils/TokenUtils';
import { useMutation } from '@tanstack/react-query';
import { useNavigate } from 'react-router-dom';
import { useSetAtom } from 'jotai';
import userInforAtom from 'atom/userInforAtom';

import { ReactComponent as Logo } from 'asserts/logo/exbody_login.svg';
import { restfetcher } from 'queryClient';
import { useCookies } from 'react-cookie';
import companyInforAtom from 'atom/companyInforAtom';
import React from 'react';
import InputBox from 'components/Input/Input';
import centerInforIdxAtom from 'atom/centerInforIdxAtom';

const Login = () => {
  const [isLogin, setIsLogin] = useState({
    id: '',
    password: ''
  });

  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const [cookies, setCookie, removeCookie] = useCookies(['dashboardToken']);

  const setUserInfor = useSetAtom(userInforAtom);
  const setCompanyInfor = useSetAtom(companyInforAtom);
  const setCenterIdx = useSetAtom(centerInforIdxAtom);

  const { showAlert } = useGlobalAlert();

  const loginMutation = useMutation({
    mutationFn: (param: LoginParam) =>
      restfetcher({
        method: 'POST',
        path: 'auth/login',
        params: param
      }),

    onSuccess: (data: any) => {
      if (data.result === 'success') {
        const { jwt, refresh } = data.authenticatetoken;
        setToken(refresh);
        setCookie('dashboardToken', jwt, { secure: true, sameSite: 'strict' });

        moveMainPage();
        setUserInfor(data.userinfo);
        setCenterIdx(data.companyInfo.centeridx);
        setCompanyInfor(data.companyInfo);
      } else if (data.result === 'failed') {
        if (data.errcode === 602) {
          showAlert('idFailure', '존재하지 않는 이메일입니다.');
        }
        if (data.errcode === 607) {
          showAlert('passwordFailure', '비밀번호가 일치하지 않습니다.');
        }
        if (data.errcode === 618) {
          showAlert('notUseFailure', '사용 권한이 없습니다.');
        }
      }
    },
    onError: (error: any) => {
      console.log(error);
    }
  });

  const navigate = useNavigate();

  const moveMainPage = () => {
    navigate('/main');
  };

  const handleLogin = async (e: any) => {
    e.preventDefault();
    const { id, password } = e.target.elements;

    loginMutation.mutate({
      usremail: id.value.trim(),
      usrpw: password.value.trim(),
      serviceid: '63d82f9820dc42eca4fdc0ec44050743'
    });
  };

  const { id, password } = isLogin;

  const handleChangeInputValue = useCallback(
    (e: React.FormEvent<HTMLInputElement>) => {
      const { value, name } = e.currentTarget;
      setIsLogin((prev) => ({
        ...prev,
        [name]: value
      }));
    },
    []
  );

  useEffect(() => {
    clearTokens();
  }, []);

  useEffect(() => {
    if (!localStorage.getItem('refresh')) {
      navigate('/');
      removeCookie('dashboardToken');
      localStorage.clear();
      sessionStorage.clear();
    }
  }, []);

  return (
    <Wrapper>
      <InnerWrapper>
        <ContentsWrapper>
          <h1>
            <Logo />
          </h1>
          <Title>Dashboard</Title>
          <form onSubmit={handleLogin}>
            <InputWrapper>
              <InputBox
                placeholder="이메일을 입력해주세요"
                name="id"
                autoFocus
                onChange={handleChangeInputValue}
                value={id}
                type="text"
              />
              <InputBox
                type="password"
                placeholder="패스워드를 입력해주세요"
                name="password"
                value={password}
                autoComplete="off"
                onChange={handleChangeInputValue}
              />
            </InputWrapper>
            <ButtonBox type="submit" className="loginButton">
              로그인
            </ButtonBox>
          </form>
        </ContentsWrapper>
        <FooterWraper>
          <Adress />
        </FooterWraper>
      </InnerWrapper>
    </Wrapper>
  );
};

export default React.memo(Login);

const Wrapper = styled.div`
  width: 100%;
  height: 100vh;
  margin: 0 auto;
  text-align: center;
  background: url('assets/login_bg.png') center no-repeat;
  background-size: cover;
  color: #ffffff;
`;

const InnerWrapper = styled.div`
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  margin: 0 auto;
  padding: 80px 40px 40px;
  background: rgba(0, 0, 0, 0.6);
  border-radius: 16px;
  backdrop-filter: blur(8px);
`;

const Title = styled.p`
  padding: 16px 0 32px;
  font-size: 20px;
  line-height: 24px;
`;

const ContentsWrapper = styled.div`
  width: 480px;
  padding-bottom: 75px;
`;

const InputWrapper = styled.div``;

const ButtonBox = styled.button`
  width: 320px;
  height: 44px;
  background: #66b6ff;
  margin-top: 32px;
  border-radius: 24px;
  color: #ffffff;
  border: none;
`;

const FooterWraper = styled.div`
  width: 480px;
  text-align: left;
`;
